<template>
    <div>
        <MobileBanner v-if="isMobile"></MobileBanner>
        <PcBanner v-else></PcBanner>
    </div>
</template>
<script>
import PcBanner from '@/components/Banner/PcBanner.vue'
import MobileBanner from '@/components/Banner/MobileBanner.vue'

export default {
  data () {
    return {
      isMobile: document.body.clientWidth < 768
    }
  },
  components: {
    PcBanner,
    MobileBanner
  }
}
</script>
